export const formatDisplayLotId = (displayLotId?: string | null): string => {
  if (!displayLotId) return "N/A";
  const trimmed = displayLotId.slice(-8);
  if (trimmed.length < 4) {
    return displayLotId;
  }
  const left = trimmed.slice(0, 4).padStart(4, "0");
  const right = trimmed.slice(4).padStart(4, "0");
  return `${left}-${right}`;
};

export const formatDisplayUserId = (displayUserId?: string | null): string => {
  if (!displayUserId) return "N/A";
  return displayUserId.replace(/^PWP-(U|PL)-/i, "").replace(/^U-/, "");
};

interface FormatDateOptions {
  includeTime?: boolean;
  fallback?: string;
}

export const formatReadableDate = (iso?: string | null, options?: FormatDateOptions): string => {
  const fallback = options?.fallback ?? "N/A";
  if (!iso) return fallback;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }
  if (options?.includeTime) {
    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  }
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
